import type { Project } from '@/types'

import { media } from '@/constants/media'

export const projects: Project[] = [
    {
        slug: 'vantra',
        title: 'Vantra',
        industry: 'Eyewear',
        year: "'26©",
        date: '2026-07-08',
        image: media.projectShots.vantra,
        video: media.video.projectVantra,
        summary: 'A campaign identity and site for a lens-first eyewear drop, built so the product reads before the copy does.',
        deliverables: ['Brand Identity', 'Art Direction', 'Web Design', 'Modulify Dev'],
        duration: '6 weeks',
        gallery: [media.projectShots.vantra, ...media.projectShoots.vantra],
        metrics: [
            { value: '+47%', label: 'qualified inbound' },
            { value: '10 days', label: 'sold out' },
            { value: '6 wks', label: 'to launch' }
        ]
    },
    {
        slug: 'lume',
        title: 'Lumé',
        industry: "Women's Skincare",
        year: "'24©",
        date: '2024-07-10',
        image: media.projectShots.lume,
        summary: 'A skincare line rebuilt around restraint: one typeface, one gesture, and a grid that lets the product breathe.',
        deliverables: ['Brand Identity', 'Web Design', 'Art Direction'],
        duration: '5 weeks',
        gallery: [media.projectShots.lume, ...media.projectShoots.lume],
        metrics: [
            { value: '+240%', label: 'waitlist growth' },
            { value: '4.9/5', label: 'customer rating' },
            { value: '5 wks', label: 'to launch' }
        ]
    },
    {
        slug: 'kestrel',
        title: 'Kestrel',
        industry: 'Technical Outerwear',
        year: "'25©",
        date: '2025-05-05',
        image: media.projectShots.kestrel,
        video: media.video.projectKestrel,
        summary: 'Technical outerwear given a technical voice. Every spec becomes a design element instead of a footnote.',
        deliverables: ['Art Direction', 'Web Design', 'Modulify Dev'],
        duration: '4 weeks',
        gallery: [media.projectShots.kestrel, ...media.projectShoots.kestrel],
        metrics: [
            { value: '+62%', label: 'time on site' },
            { value: '100%', label: 'shipped on time' },
            { value: '4 wks', label: 'to launch' }
        ]
    },
    {
        slug: 'baseline',
        title: 'Baseline',
        industry: 'Tennis Apparel',
        year: "'25©",
        date: '2025-04-15',
        image: media.projectShots.baseline,
        summary: 'A tennis capsule that had to move as fast as the sport. Motion-first art direction, built to be cut a hundred ways.',
        deliverables: ['Art Direction', 'Brand Identity', 'Web Design'],
        duration: '6 weeks',
        gallery: [media.projectShots.baseline, ...media.projectShoots.baseline],
        metrics: [
            { value: '+38%', label: 'conversion lift' },
            { value: '3 rounds', label: 'to sign-off' },
            { value: '6 wks', label: 'to launch' }
        ]
    },
    {
        slug: 'meridian',
        title: 'Meridian',
        industry: 'Sportswear',
        year: "'25©",
        date: '2025-01-01',
        image: media.projectShots.meridian,
        summary: 'Sportswear without the shouting. A quieter system that still lands from across the room.',
        deliverables: ['Brand Identity', 'Web Design', 'Modulify Dev', 'Art Direction'],
        duration: '7 weeks',
        gallery: [media.projectShots.meridian, ...media.projectShoots.meridian],
        metrics: [
            { value: '+51%', label: 'return visits' },
            { value: '2.1s', label: 'load time' },
            { value: '7 wks', label: 'to launch' }
        ]
    },
    {
        slug: 'forge',
        title: 'Forge',
        industry: 'Training',
        year: "'23©",
        date: '2023-02-01',
        image: media.projectShots.forge,
        summary: 'A training platform rebuilt around one number: how quickly can someone find the session they came for.',
        deliverables: ['Web Design', 'Modulify Dev'],
        duration: '5 weeks',
        gallery: [media.projectShots.forge, ...media.projectShoots.forge],
        metrics: [
            { value: '-40%', label: 'bounce rate' },
            { value: '+29%', label: 'session starts' },
            { value: '5 wks', label: 'to launch' }
        ]
    }
]

export const getProject = (slug: string): Project | undefined => {
    return projects.find((project) => project.slug === slug)
}
